import theme from 'ThemeProvider/theme';
import sx from 'utils/createSx';

export default sx({
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    p: 4,
    backgroundColor: '#f9f9f9',
  },
  subtitle: {
    fontWeight: 'bold',
    mb: 2,
    color: theme.palette.primary.main,
  },
  card: {
    borderRadius: 4,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    mb: 2,
  },
  paymentHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    p: 2,
  },
  icon: {
    fontSize: 40,
    color: theme.palette.primary.main,
  },
  summaryCard: {
    borderRadius: 4,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    p: 2,
    backgroundColor: '#fff',
  },
  productText: {
    fontWeight: 'bold',
    mb: 1,
  },
  quantityText: {
    mb: 1,
    color: theme.palette.text.secondary,
  },
  itemTotalText: {
    mb: 1,
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  summaryContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mt: 1,
    mb: 1,
  },
  summaryText: {
    color: theme.palette.text.secondary,
  },
  summaryValue: {
    fontWeight: 'bold',
  },
  totalText: {
    fontWeight: 'bold',
  },
  totalValue: {
    color: theme.palette.success.main,
    fontWeight: 'bold',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mt: 4,
  },
  backButton: {
    color: theme.palette.text.secondary,
  },
  advanceButton: {
    backgroundColor: theme.palette.success.main,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.success.dark,
    },
  },
});
